const Function = require('core/src/function');
const API = Function.extend(Function, 'API');
const Edition = require('core/src/edition').default;

Edition.setBuildFeature(Edition.Feature.FUNCTION_API, false);

API.Event = {
	Out: {
		RESPONSE: 'response',
		ERROR: 'apiError',
		CLOSE_CONNECTION: 'closeConnection'
	}
};

API.prototype.onInit = function() {
	this.setParameters({
		'$end': true, // Connection will close automatically after the first response. Set this to false for streaming
		'$error': undefined,
		// Using evaluate because setParameter throws error for keys
		// Default headers for streaming responses
		'$headers': `evaluate({
			'Content-Type': 'application/json',
			'Transfer-Encoding': 'chunked'
		})`,
		'$input': undefined,
		'$method': 'post',
		'$response': undefined,
		'$status': 200,
		'$stayAlive': 'session',
		'$timeout': 60000, //60 seconds
	});
};

API.prototype.execute = function(...args) {
	// feature
	const error = Edition.functionNotAvailableError('API');
	this.error(error);
	throw error;
};

API.prototype.onUpdate = function() {
	// feature
};

API.prototype.onExecute = function() {
	// feature
};

module.exports = API;
